import React from 'react'
import Footer from '../Footer'
import EducationCLRHS1 from '../EducationCLRHS1'

function CLRHS1() {
    window.scrollTo(0,0);
    return (
        <div>
            <EducationCLRHS1/>
            <Footer/>
        </div>
    )
}

export default CLRHS1
